<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eSljs0/tc-custom/9780062973368.jpg?1737196543401" alt="This image is the cover for the book Revolt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Revolt
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A well-written and thought-provoking account of the current crisis of globalization. Not everyone will agree with Eyal's interpretation, but few will remain indifferent." </b><b>—Yuval Noah Harari, author of <i>Sapiens</i>    </b></p><p><b>An eye-opening examination of nationalism’s spread around the world as the promise of globalism wanes</b></p><p><i>Revolt</i> is an eloquent and provocative challenge to the prevailing wisdom about the rise of nationalism and populism. With a vibrant and informed voice, Nadav Eyal illustrates how modern globalization is not sustainable. He contends that the collapse of the current world order is not so much about the imbalance between technological achievement and social progress or the breakdown of liberal democracy as it is about a passion to upend and destroy power structures that have become hollow, corrupt. or simply unresponsive to urgent needs. Eyal illuminates the benign and malignant forces that have so rapidly transformed our economic, political, and cultural realities, shedding light not only on the economic and cultural revolution that has come to define our time but also on the counterrevolution waged by those it has marginalized and exploited.</p><br/><p>With a mixture of journalistic narrative, penetrating vignettes, and original analysis, <i>Revolt</i> shows that the left and right have much in common. Eyal tells stories of distressed Pennsylvania coal miners, anarchist communes on the outskirts of Athens, a Japanese town with collapsing fertility rates, neo-Nazis in Germany, and Syrian refugee families whom he accompanied from the shores of Greece to their destination in Germany. Into these reports from the present Eyal weaves lessons from the past, from the opium wars in China to colonialist Haiti to the Marshall Plan. With these historical ties, he shows that the revolts’ roots have always been deep and strong, and that rather than seeing current uprisings as part of a passing phenomenon, we should recognize that revolt is the new status quo. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nadav Eyal
      </h2>
      
      <p class="authorDescription body article"><P>Nadav Eyal<B></B>is one of Israel&#8217;s most well-known journalists, and a winner of the Sokolov Prize, Israel&#8217;s Pulitzer. He is the chief international correspondent for Israel&#8217;s Reshet News, and an opinion writer for <I>Yediot Aharont</I>, Israel&#8217;s most circulated newspaper. In 2016, several months before the presidential elections, Eyal aired Trumpland, a series of short documentaries detailing the grievances haunting America, specifically the rust belt. These received much attention for presenting the prospect of a Trump victory. He holds an LLB from the Law Faculty at Hebrew University in Jerusalem and a master&#8217;s degree in global politics from the London School of Economics.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d84904e